import axios from 'axios';
import endpoints from '@configs/endpoints';
import { IPaymentError } from '@containers/checkout/payment-form/types';
import debug from 'debug';
import { PaymentMethodMap } from '@store/checkout';

const err = debug('Payment:error');

const sendPaymentError = (data: IPaymentError): void => {
  axios
    .post(endpoints.createPaymentOrderError, {
      payeeFirstName: data.payeeFirstName,
      payeeLastName: data.payeeLastName,
      payeeEmail: data.payeeEmail,
      payeePhone: data.payeePhone,
      paymentMethod: PaymentMethodMap[data.paymentMethod],
      paymentLinkId: data.paymentLinkId,
      partner: data.partner,
      zipCode: data.zipCode,
      currency: data.currency,
      error: data.error,
      cardInfo: data.cardInfo,
    })
    .catch((e) => err('Something went sending the payment error %o', e));
};
export default sendPaymentError;
